import { AccessLevel } from '../../../../types/AccessLevel';
import { CompanyAccessMessage } from '../../../../types/CompanyAccessMessage';
import { UserRole } from '../../../../types/UserRole';
import { useEnums } from '../../../common/hooks/useEnums';

interface PersonalRoleProps {
    accessLevel: AccessLevel;
    companyAccesses: CompanyAccessMessage[];
}

export const PersonalRole = ({ accessLevel, companyAccesses }: PersonalRoleProps) => {
    const { getHumanReadableValue } = useEnums();

    if (accessLevel === AccessLevel.ADMIN) {
        return getHumanReadableValue('role', UserRole.GROUP_ADMIN);
    }

    if (accessLevel === AccessLevel.WRITE) {
        return getHumanReadableValue('role', UserRole.COMPANY_ADMIN);
    }

    if (companyAccesses.every((access) => access.accessLevel === AccessLevel.WRITE)) {
        return getHumanReadableValue('role', UserRole.COMPANY_EMPLOYEE);
    }

    if (companyAccesses.every((access) => access.accessLevel === AccessLevel.READ)) {
        return getHumanReadableValue('role', UserRole.COMPANY_INSPECTOR);
    }

    return null;
};
